/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {BaseComponent, CartProduct, CartSpecification} from 'compob2b-libs';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../../environments/translations.ru';
import {NbIconModule, NbInputModule} from "@nebular/theme";
import {DigitOnlyDirective} from "@uiowa/digit-only";
import {LowerCasePipe, NgIf} from "@angular/common";

@Component({
    selector: 'app-specification-add-to-cart',
    templateUrl: './specification-add-to-cart.component.html',
  imports: [NbInputModule, FormsModule, DigitOnlyDirective, ReactiveFormsModule, LowerCasePipe, NbIconModule, NgIf]
})
export class SpecificationAddToCartComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() specification: CartSpecification;
  @Input() cartProduct: CartProduct;
  @Output() recount = new EventEmitter<CartProduct>();
  public multiplicityOrder = 1;
  public multiplicityHeader = translations.packageBy;
  inputFormControl: UntypedFormControl;
  private inputSub$ = new Subject<number>();

  ngOnInit(): void {

    this.inputFormControl = new UntypedFormControl();

    let multiplicity = 1;

    if (this.cartProduct.multiplicityOrder > 0) {
      multiplicity = this.cartProduct.multiplicityOrder;
    }

    if (multiplicity > 0) {
      this.multiplicityOrder = multiplicity;
    }

    this.manual(this.cartProduct.amount);

    this.inputSub$.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe),
      tap(val => this.manual(val))
    ).subscribe();

    this.inputFormControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((value: number) => this.cartProduct.amount === value),
      tap(_ => this.recount.emit(this.cartProduct)),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  increase() {
    this.changeInputValue(this.inputFormControl.value + this.multiplicityOrder);
  }

  decrease() {
    const res = this.inputFormControl.value - this.multiplicityOrder;

    if (res % this.multiplicityOrder === 0 && res > 0) {
      this.changeInputValue(res);
    }
  }

  onKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
        this.increase();
        break;
      case 'ArrowDown':
        this.decrease();
        break;
    }
  }

  manualChange() {
    this.inputSub$.next(this.inputFormControl.value);
  }

  private calcMultiplicityValue(value: number): number {
    const res = Math.ceil(value / this.multiplicityOrder) * this.multiplicityOrder;
    return res === 0 ? this.multiplicityOrder : res;
  }

  private manual(value: number) {
    const val = this.calcMultiplicityValue(value);
    this.changeInputValue(val);
  }

  private changeInputValue(value: number) {
    this.inputFormControl.setValue(value);
    this.cartProduct.amount = value;
  }

}
